import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { fetchByFeature } from '../../../utils/TableHeads/FetchByFeature';

function createData(
  id,
  name,
  email,
  mobile,
  status
) {
  return {
    id,
   name,
  email,
  mobile,
  status,
    history: [
      {
        date: '2020-01-05',
        customerId: '11091700',
        amount: 3,
      },
      {
        date: '2020-01-02',
        customerId: 'Anonymous',
        amount: 1,
      },
    ],
  };
}

function CommonTableHead({ tableHeads, feature }) {
  console.log("tableHeads in collapsible",tableHeads);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  React.useEffect(() => {
    let mounted = true;
    setLoading(true);

    if (feature) {
      fetchByFeature(feature, page, rowsPerPage)
        .then((data) => {
          if (!mounted) return;
          // Handle new response format: { items, total, page, limit }
          setRows(Array.isArray(data.items) ? data.items : []);
        })
        .catch((err) => {
          console.error('Error fetching rows for feature', feature, err);
          if (mounted) setRows([]);
        })
        .finally(() => {
          if (mounted) setLoading(false);
        });
    } else {
      setRows([]);
      setLoading(false);
    }

    return () => {
      mounted = false;
    };
  }, [feature, page, rowsPerPage]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            {tableHeads.headers.map((head) => (
              <TableCell key={head} align="center">
                {head}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={tableHeads.length + 1} align="center">
                Loading...
              </TableCell>
            </TableRow>
          ) : rows.length ? (
            rows.map((row) => <Row key={row.id || row.name} row={row} tableHeads={tableHeads} />)
          ) : (
            <TableRow>
              <TableCell colSpan={tableHeads.length + 1} align="center">
                No records found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function Row(props) {
  const { row, tableHeads } = props;
  console.log("row in collapsible",tableHeads);
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {tableHeads.dataSets.map((key) => {
          if (key === 'history') return null;
          return (
            <TableCell key={key} align="center">
              {row[key] ?? '-'}
            </TableCell>
          );
        })}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={tableHeads.dataSets.length + 1}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                History
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell align="right">Amount</TableCell>
                    <TableCell align="right">Total price ($)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(row.history || []).map((historyRow) => (
                    <TableRow key={historyRow.date || Math.random()}>
                      <TableCell>{historyRow.date ?? '-'}</TableCell>
                      <TableCell>{historyRow.customerId ?? '-'}</TableCell>
                      <TableCell align="right">{historyRow.amount ?? '-'}</TableCell>
                      <TableCell align="right">
                        {Math.round((Number(historyRow.amount || 0) * Number(row.price || 0)) * 100) / 100}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
// ==============================|| USERS TABLE ||============================== //
// 
export default function CollapsibleTable(props) {
  return (
    <CommonTableHead tableHeads={props.tableHeads} feature={props.feature} />
  );
}